import {
    Box,
    Button,
    createStyles,
    Drawer,
    Grid,
    IconButton,
    Paper,
    TextField,
    Theme,
    Typography,
    WithStyles,
} from "@material-ui/core";
import { AddCircle, AttachFile } from "@material-ui/icons";
import { withStyles } from "@material-ui/styles";
import classNames from "classnames";
import * as React from "react";
import { isBrowser, isMobile } from "react-device-detect";
import {
    getImageCollection,
    getQuestionCollection,
} from "shared/src/network/requests/poll/poll-req";
import { userCreatePoll, userGet, userUpdate } from "shared/src/network/requests/user/user-req";
import { HEIGHT_LOWER_THRESHOLD } from "src/const";
import { commonClasses, spacing } from "src/styles";
import theme, { colors } from "src/theme";
import { getMediaPath } from "../utils/media";
declare global {
    interface Window {
        fbq: any;
    }
}

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        ...spacing(theme),
        helperText: {
            marginLeft: "5px",
        },
        pollContainer: {
            backgroundColor: theme.palette.grey[50],
            WebkitTapHighlightColor: "transparent",
            "@media (max-height: 850px)": {
                maxWidth: "400px",
            },
        },

        commentInput: {
            alignItems: "center",
            width: "100%",
            height: "100%",
            "& .MuiInputBase-root": {
                borderRadius: 5,
                paddingTop: 4,
                paddingLeft: 8,
                width: "90%",
                height: "100%",
            },
            "& .MuiInputBase-root::after": {
                borderBottom: "2px solid rgba(0,0,255,0.3)",
            },
            "& .MuiInputBase-root::before": {
                borderBottom: "2px solid rgba(0,0,255,0.3)",
            },
            "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                    borderColor: "#1565C0",
                },
            },
            "& .MuiOutlinedInput-input": {
                paddingX: `${theme.spacing(1)}`,
                fontSize: "18px",
                borderColor: "#1565C0",
                //textAlign: "center"
            },
            "& .MuiInput-input": {
                textAlign: "center",
            },
            "@media (max-width: 435px)": {
                fontSize: "3px",
                "& .MuiOutlinedInput-input": {
                    fontSize: "14px",
                },
            },
            "@media (max-width: 390px)": {
                "& .MuiOutlinedInput-input": {
                    paddingTop: `${theme.spacing(1.0)}`,
                    fontSize: "13px",
                },
                "& .MuiInput-input": {
                    fontSize: "11px",
                },
            },
            "@media (max-width: 350px)": {
                "& .MuiOutlinedInput-input": {
                    paddingTop: `${theme.spacing(1)}`,
                    fontSize: "10px",
                },
                "& .MuiInput-input": {
                    fontSize: "11px",
                },
            },
        },
        optionInput: {
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#ffffff",
                border: "0px",
            },
        },
        questionInput: {
            "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: "1px",
                borderRadius: "5px",
                borderColor: "#1565C0",
            },
            "& .MuiOutlinedInput-input": {
                fontWeight: "500",
                //textAlign: "center"
            },
        },
        commentInputDiv: {
            width: "100%",
        },
        nameWidth: {
            "& .MuiInputBase-root": {
                borderRadius: 5,
                marginLeft: "-15%",
                width: "75%",
            },
        },
        questionContainer: {
            width: `calc(100% + ${theme.spacing(3)})`,
            height: `calc(100% + ${theme.spacing(1.5)})`,
            marginLeft: "-12px",
            marginBottom: theme.spacing(-1.5),
            backgroundColor: theme.palette.grey[100],
            padding: theme.spacing(1),
            position: "relative",
            "& .css-shmgrm-MuiGrid-root": {
                marginLeft: "-24px",
                width: "calc(100% + 40px)",
                "& .MuiGrid-item": {
                    paddingLeft: "6px",
                    paddingTop: "6px",
                },
            },
        },
        questionListItem: {
            "@media (max-width: 390px)": {
                fontSize: "14px",
            },
        },
        ImageListHeader: {
            "@media (max-width: 390px)": {
                fontSize: "11px",
            },
        },
        statusImage: {
            top: "-20%",
            right: "-8%",
            width: "50%",
            opacity: "30%",
            position: "absolute",
        },
        optionLabel: {
            position: "absolute",
            zIndex: 2,
            padding: "2px 4px",
            borderRadius: 0,
            lineHeight: 0,
            borderBottomRightRadius: "4px",
            "& .MuiTypography-root": {
                lineHeight: 1,
            },
        },
        optionImg: {
            objectFit: "contain",
            width: `100%`,
            height: `100%`,
        },
        optionResultBg: {
            position: "absolute",
            right: 0,
            bottom: 0,
            left: 0,
        },
        optionResultValueContainer: {
            position: "absolute",
            width: "64%",
            textAlign: "center",
            bottom: "-8px",
            color: "white",
            borderRadius: 4,
        },
        optionPaper: {
            position: "relative",
            width: "100%",
            border: "1px solid #1565C0",
        },
        optionError: {
            border: "4px solid rgba(217,0,0,1)",
        },
        optionContent: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
        },
        optionFocus: {
            border: "4px solid #1565C0",
        },
        textWithImage: {
            color: "white",
            position: "absolute",
        },
        gradient: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            position: "absolute",
            background: "linear-gradient(transparent, rgba(0,0,0,0.6))",
        },
        optionMediaText: {
            color: "white",
        },
        scroll: {
            overflow: "scroll",
        },
        error: {
            border: "2px solid red",
        },
        trackSwitch: {
            "& .Mui-checked": {
                color: colors.components.switch.red,
                "&+.MuiSwitch-track": {
                    backgroundColor: colors.components.switch.red,
                },
            },
        },
        privatePoll: {
            marginTop: "-2%",
        },
        errorText: {
            marginLeft: "5%",
            fontSize: "0.7rem",
            color: "rgba(217, 0,0, 1)",
        },
    });

type Props = WithStyles<typeof styles> & {
    onPollAdd: (pollId: string) => void;
};

type State = {
    incompleteFields?: InputDataFields[];
    showFourOptions: boolean;
    currentSelectedIndex: string;
    drawerOpen: boolean;
    showQuestionTray: boolean;
    optionImg: any;
    isProcessing: boolean;
    showPencil: boolean;
    showError: boolean;
};

type InputDataFields = "name" | "question" | "option1" | "option2" | "option3" | "option4";
type CreateOption = {
    text: string[];
    image: string[];
};
class Component extends React.Component<Props, State> {
    inputRefs: any;
    questionArr: string[];
    imgSrcList: string[];
    insideHeight: number;
    constructor(props: Props) {
        super(props);
        this.inputRefs = {
            name: React.createRef(),
            question: React.createRef(),
            option1: React.createRef(),
            option2: React.createRef(),
            option3: React.createRef(),
            option4: React.createRef(),
        };

        this.questionArr = [];
        this.imgSrcList = [];
        this.state = {
            showFourOptions: false,
            currentSelectedIndex: "",
            drawerOpen: false,
            showQuestionTray: false,
            optionImg: {
                option1: "",
                option2: "",
                option3: "",
                option4: "",
            },
            isProcessing: false,
            showPencil: false,
            showError: true,
        };
        this.insideHeight = window.innerHeight - 88;
    }

    calculateDimensions = () => {
        let availableHeight = this.insideHeight;
        const ratio = (availableHeight || 0) < HEIGHT_LOWER_THRESHOLD ? 1.25 : 1.5;
        let availableWidth = availableHeight ? availableHeight / ratio : undefined;
        if (availableWidth) {
            if (availableWidth > window.innerWidth) {
                availableWidth = window.innerWidth;
            }
            availableWidth -= 16;
        }
        const requiredWidth = ((availableHeight || 0) - 170) / 1.23;
        let hGap;
        if (availableWidth && requiredWidth < availableWidth) {
            hGap = (availableWidth - requiredWidth) / 2;
        }
        return {
            availableWidthForMobile: availableWidth,
            hGapForMobile: hGap,
        };
    };
    componentDidMount = async () => {
        //This section is for autofilling user name
        //=============================================
        userGet({})
            .then((userGetResponse) => {
                this.inputRefs["name"].current.value = userGetResponse?.user?.name || "";
            })
            .catch(() => {});
        const questionCollectionResponse = await getQuestionCollection({});
        this.questionArr = [...questionCollectionResponse["questionList"]];
        const imageCollectionResponse = await getImageCollection({});
        this.imgSrcList = [...imageCollectionResponse["imageSrcList"]];
        window.addEventListener("scroll", this.handleScrollTop);
    };

    handleScrollTop = () => {
        window.scrollTo(0, 0);
    };
    handleQuestionTray = () => {
        const { question } = this.inputRefs;
        question.current.value !== ""
            ? this.setState({ showQuestionTray: false, showError: false })
            : this.setState({ showQuestionTray: true, showError: true });
    };
    handleImageDrawer = () => {
        this.setState({ drawerOpen: true });
    };

    setQuestion = (index: number) => {
        const { question } = this.inputRefs;
        question.current.value = this.questionArr[index];
        this.handleQuestionTray();
    };
    handleImageChange = (imgSrc: string) => {
        const { optionImg, currentSelectedIndex } = this.state;
        let currentState = { ...optionImg };
        currentState[currentSelectedIndex] = imgSrc;
        this.setState({ optionImg: { ...currentState } });
    };

    renderOptionField = (
        label: string,
        field: string,
        maxLength?: number,
        type?: string,
        error?: string
    ) => {
        const { classes } = this.props;
        const { optionImg } = this.state;
        const { incompleteFields } = this.state;
        let errorField = field as string;

        error = !!(incompleteFields && incompleteFields.indexOf(field as InputDataFields) !== -1)
            ? "Please enter " + (field === "question" ? errorField : "option")
            : "";
        return (
            <Grid item className={classNames(classes.commentInputDiv)}>
                <TextField
                    key={field}
                    className={classNames(classes.commentInput, classes.optionInput)}
                    placeholder={label}
                    name={field}
                    inputRef={this.inputRefs[field]}
                    variant={undefined}
                    fullWidth
                    multiline={true}
                    rows={3}
                    onChange={this.getInputValues}
                    inputProps={{
                        maxLength,
                        style: { color: `${!!optionImg[field] ? "white" : "black"}` },
                    }}></TextField>
                {!optionImg[field] && (
                    <>
                        <Box
                            position="absolute"
                            width="25px"
                            height="25px"
                            sx={{
                                bottom: "6%",
                                right: "6%",
                                borderRadius: "50%",
                                backgroundColor: "#1565C0",
                                cursor: "pointer",
                            }}>
                            <IconButton
                                sx={{ width: "23px", height: "23px" }}
                                onClick={this.handleImageDrawer}>
                                <AttachFile sx={{ transform: "rotate(45deg)", color: "white" }} />
                            </IconButton>
                        </Box>
                    </>
                )}
                {!!optionImg[field] && (
                    <>
                        <Box position="absolute" sx={{ right: "5px", top: "5px" }}>
                            <Box width="20px" height="20px">
                                <Box
                                    component="img"
                                    sx={{
                                        cursor: "pointer",
                                    }}
                                    width="20px"
                                    height="20px"
                                    onClick={() => {
                                        this.handleImageChange("");
                                    }}
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/images/delete-a3d165a6af3daa3dcb6c39bfe8bb9843.webp"
                                    }></Box>
                            </Box>
                        </Box>
                    </>
                )}
            </Grid>
        );
    };

    renderTextField = (
        label: string,
        field: InputDataFields,
        maxLength?: number,
        type?: string,
        error?: string
    ) => {
        const { question: questionRef } = this.inputRefs;
        const { classes } = this.props;
        const { incompleteFields, showError } = this.state;
        error = !!(incompleteFields && incompleteFields.indexOf(field) !== -1)
            ? "Please enter question"
            : "";
        return (
            <Grid item className={classNames(classes.commentInputDiv)}>
                <TextField
                    key={field}
                    className={classNames(
                        classes.commentInput,
                        {
                            [classes.nameWidth]: field === "name",
                        },
                        {
                            [classes.questionInput]: field === "question",
                        }
                    )}
                    placeholder={label}
                    name={field}
                    inputRef={this.inputRefs[field]}
                    onFocus={() => {
                        if (field === "question") {
                            this.handleQuestionTray();
                        }
                    }}
                    onBlur={() => {
                        if (field === "question") {
                            if (questionRef.current.value !== "") {
                                this.setState({ showPencil: true });
                            } else {
                                this.setState({ showPencil: false });
                            }
                        }
                    }}
                    onChange={() => {
                        if (field === "question") {
                            this.handleQuestionTray();
                        }
                    }}
                    error={!!error && showError}
                    fullWidth
                    variant={field === "name" ? "standard" : "outlined"}
                    multiline={field !== "name" ? true : false}
                    rows={2}
                    //helperText={(!!error && error) || ""}
                    inputProps={{ maxLength }}></TextField>
                {showError && !!error ? (
                    <span className={classNames(classes.errorText)}>{error}</span>
                ) : undefined}
            </Grid>
        );
    };
    getInputValues = () => {
        const {
            name: nameRef,
            question: questionRef,
            option1: option1Ref,
            option2: option2Ref,
            option3: option3Ref,
            option4: option4Ref,
        } = this.inputRefs;
        return {
            name: nameRef.current ? nameRef.current.value : "",
            question: questionRef.current ? questionRef.current.value : "",
            option1: option1Ref.current ? option1Ref.current.value : "",
            option2: option2Ref.current ? option2Ref.current.value : "",
            option3: option3Ref.current ? option3Ref.current.value : "",
            option4: option4Ref.current ? option4Ref.current.value : "",
        };
    };
    incompleteFields = () => {
        const { question, option1, option2, option3, option4 } = this.getInputValues();
        const { option1: img1, option2: img2, option3: img3, option4: img4 } = this.state.optionImg;
        const incompleteFields: InputDataFields[] = [];
        if (!question) {
            incompleteFields.push("question");
        }
        if (!option1 && !img1) {
            incompleteFields.push("option1");
        }
        if (!option2 && !img2) {
            incompleteFields.push("option2");
        }
        if (!!option3 || !!img3 || !!option4 || !!img4) {
            if (!option3 && !img3) {
                incompleteFields.push("option3");
            }
            if (!option4 && !img4) {
                incompleteFields.push("option4");
            }
        }

        return incompleteFields;
    };
    resetAllFields = () => {
        if (!!this.inputRefs["question"].current) this.inputRefs["question"].current.value = "";
        if (!!this.inputRefs["option1"].current) this.inputRefs["option1"].current.value = "";
        if (!!this.inputRefs["option2"].current) this.inputRefs["option2"].current.value = "";
        if (!!this.inputRefs["option3"].current) this.inputRefs["option3"].current.value = "";
        if (!!this.inputRefs["option4"].current) this.inputRefs["option4"].current.value = "";
        this.setState({
            incompleteFields: undefined,
            showFourOptions: false,
            currentSelectedIndex: "",
            drawerOpen: false,
            showQuestionTray: false,
            optionImg: {
                option1: "",
                option2: "",
                option3: "",
                option4: "",
            },
            isProcessing: false,
        });
    };
    onSubmit = async () => {
        const { onPollAdd } = this.props;
        const { name, question, option1, option2, option3, option4 } = this.getInputValues();
        const { option1: img1, option2: img2, option3: img3, option4: img4 } = this.state.optionImg;
        const incompleteFields = this.incompleteFields();
        //Form Validation
        if (!!incompleteFields && incompleteFields.length > 0) {
            this.setState({ incompleteFields });
        } else {
            this.setState({ isProcessing: true });
            const options: Array<CreateOption> = [];
            options.push({ text: [option1], image: [img1] });
            options.push({ text: [option2], image: [img2] });
            if (!!option3 || !!img3) {
                options.push({ text: [option3], image: [img3] });
            }
            if (!!option4 || !!img4) {
                options.push({ text: [option4], image: [img4] });
            }
            const pollData = {
                name,
                questionText: [question],
                options,
            };
            await userUpdate({ name });
            const pollRes = await userCreatePoll(pollData);
            onPollAdd(pollRes.pollId);
            this.resetAllFields();
        }
    };
    public render() {
        const { classes } = this.props;
        const {
            showFourOptions,
            currentSelectedIndex,
            drawerOpen,
            // showQuestionTray,
            optionImg,
            isProcessing,
        } = this.state;
        let hGap;
        let availableWidth;

        const optionArray = ["option1", "option2", "option3", "option4"];
        const optionNames = ["A", "B", "C", "D"];
        if (isBrowser) {
            const availableHeight = window.innerHeight - 88;
            const ratio = (availableHeight || 0) < HEIGHT_LOWER_THRESHOLD ? 1.25 : 1.5;
            availableWidth = availableHeight ? availableHeight / ratio : undefined;
            if (availableWidth) {
                if (availableWidth > window.innerWidth) {
                    availableWidth = window.innerWidth;
                }
                availableWidth -= 16;
            }
            const requiredWidth = ((availableHeight || 0) - 170) / 1.23;
            if (availableWidth && requiredWidth < availableWidth) {
                hGap = (availableWidth - requiredWidth) / 2;
            }
        }
        if (isMobile) {
            const { availableWidthForMobile, hGapForMobile } = this.calculateDimensions();
            availableWidth = availableWidthForMobile;
            hGap = hGapForMobile;
        }
        return (
            <Grid container item id="create-component" alignItems="center" justifyContent="center">
                <Paper
                    elevation={3}
                    className={classNames(classes.pollContainer)}
                    id="create-component-paper"
                    sx={{
                        width: availableWidth,
                    }}>
                    <Grid container direction="column" wrap="nowrap">
                        <Grid
                            item
                            sx={{
                                zIndex: 1,
                                backgroundColor: "white",
                                borderTopRightRadius: 10,
                                borderTopLeftRadius: 10,
                            }}>
                            <Grid container>
                                <Grid
                                    item
                                    sx={{
                                        marginBottom: "10px",
                                    }}>
                                    {this.renderTextField("Name (optional)", "name", 15)}
                                </Grid>
                            </Grid>
                            {/* Header */}
                        </Grid>

                        <Box
                            height="20%"
                            sx={{
                                backgroundColor: "theme.palette.grey[50]",
                            }}>
                            <Grid item xs>
                                <Grid container direction="column">
                                    <Grid item xs sx={{ marginY: "10px" }}>
                                        {this.renderTextField(
                                            "Type your Flash Question Here...",
                                            "question",
                                            90,
                                            "outlined"
                                        )}
                                    </Grid>
                                    {/* {showQuestionTray === true && (
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center">
                                            <Grid
                                                item
                                                onScroll={() => {
                                                    console.log("Question list scrolled...");
                                                }}
                                                sx={{ position: "relative", width: "90%" }}>
                                                // Question List
                                                <Paper
                                                    id={"question-suggestion-list"}
                                                    onScroll={() => {
                                                        console.log("Question list scrolled...");
                                                    }}
                                                    sx={{
                                                        width: "100%",
                                                        borderRadius: "10px",
                                                        overflow: "scroll",
                                                        height: "250px",
                                                        position: "absolute",
                                                        zIndex: 3,
                                                        backgroundColor: "rgba(231, 235, 241, 1)",
                                                    }}>
                                                    {this.questionArr.map((element, index) => {
                                                        return (
                                                            <Box
                                                                sx={{
                                                                    textAlign: "center",
                                                                    paddingY: "8px",
                                                                }}
                                                                className={classNames(
                                                                    classes.mb,
                                                                    classes.mt
                                                                )}
                                                                onClick={() => {
                                                                    this.setQuestion(index);
                                                                }}>
                                                                <Typography
                                                                    noWrap
                                                                    sx={{
                                                                        paddingX: "10px",
                                                                    }}
                                                                    className={
                                                                        classes.questionListItem
                                                                    }
                                                                    variant="h6">
                                                                    {element}
                                                                </Typography>
                                                            </Box>
                                                        );
                                                    })}
                                                </Paper>
                                            </Grid>
                                        </Grid>
                                    )} */}
                                </Grid>
                            </Grid>
                        </Box>
                        <Box
                            height="80%"
                            sx={{
                                overflowY: "auto",
                                overflowX: "hidden",
                                backgroundColor: "theme.palette.grey[50]",
                            }}>
                            {/* Poll Options */}
                            <Grid
                                item
                                sx={{
                                    paddingX: `${(hGap || 0) + 16}px`,
                                }}>
                                <Grid
                                    container
                                    sx={{
                                        p: 1,
                                    }}
                                    spacing={2}>
                                    {optionArray.map((element, index) => {
                                        let error = "";
                                        if (showFourOptions === false) {
                                            if (index >= 2) {
                                                return <></>;
                                            }
                                        }
                                        const { incompleteFields } = this.state;

                                        error = !!(
                                            incompleteFields &&
                                            incompleteFields.indexOf(element as InputDataFields) !==
                                                -1
                                        )
                                            ? "Please enter option"
                                            : "";
                                        return (
                                            <Grid
                                                direction="row"
                                                item
                                                xs={6}
                                                sx={{ position: "relative" }}
                                                justifyContent="center">
                                                <Paper
                                                    id="create-option-paper"
                                                    elevation={0}
                                                    sx={{
                                                        overflow: "hidden",
                                                        paddingTop: "120%",
                                                        backgroundColor: "theme.palette.grey[100]",
                                                        borderRadius: "10px",
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            currentSelectedIndex: element,
                                                        });
                                                    }}
                                                    className={classNames(classes.optionPaper, {
                                                        [classes.optionFocus]:
                                                            currentSelectedIndex === element &&
                                                            !error,
                                                        [classes.optionError]: !!error,
                                                    })}>
                                                    {!!optionImg[element] && (
                                                        <>
                                                            <Box
                                                                component={"img"}
                                                                sx={{ border: "0px", top: "0%" }}
                                                                position="absolute"
                                                                height="100%"
                                                                width="100%"
                                                                src={
                                                                    !!optionImg[element]
                                                                        ? getMediaPath(
                                                                              optionImg[element]
                                                                          )
                                                                        : optionImg[element]
                                                                }></Box>
                                                            <Box
                                                                height="100%"
                                                                width="100%"
                                                                position="absolute"
                                                                sx={{
                                                                    backgroundColor:
                                                                        "rgba(0, 0, 0, 0.20)",
                                                                    top: "0%",
                                                                }}></Box>
                                                        </>
                                                    )}
                                                    <Box className={classes.optionContent}>
                                                        {this.renderOptionField(
                                                            `Type option ${optionNames[index]}...`,
                                                            `${element}`,
                                                            50
                                                        )}
                                                    </Box>
                                                    <Typography
                                                        variant="body2"
                                                        position="absolute"
                                                        sx={{
                                                            color: "rgba(217,0,0,1)",
                                                            top: "5px",
                                                            left: "5px",
                                                            fontSize: "0.7rem",
                                                        }}>
                                                        {error}
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        );
                                    })}
                                    {showFourOptions === false && (
                                        <Grid
                                            item
                                            xs={6}
                                            className={classes.mt}
                                            onClick={() => {
                                                this.setState({
                                                    showFourOptions: !showFourOptions,
                                                });
                                            }}>
                                            <Box
                                                sx={{
                                                    paddingTop: "120%",
                                                    width: "200%",
                                                    position: "relative",
                                                }}>
                                                <Box
                                                    position="absolute"
                                                    sx={{
                                                        top: "0px",
                                                    }}>
                                                    <AddCircle
                                                        color="primary"
                                                        sx={
                                                            isBrowser
                                                                ? {
                                                                      display: "inline-block",
                                                                      height: "16px",
                                                                      width: "16px",
                                                                  }
                                                                : {
                                                                      display: "inline-block",
                                                                      height: "12px",
                                                                      width: "12px",
                                                                  }
                                                        }
                                                        onClick={() => {
                                                            this.setState({
                                                                showFourOptions: !showFourOptions,
                                                            });
                                                        }}
                                                    />
                                                    <Typography
                                                        className={classes.ml}
                                                        variant="h6"
                                                        color="#1565C0"
                                                        sx={
                                                            isBrowser
                                                                ? {
                                                                      display: "inline-block",
                                                                      fontSize: "18px",
                                                                      fontWeight: "500",
                                                                  }
                                                                : {
                                                                      display: "inline-block",
                                                                      fontSize: "14px",
                                                                      fontWeight: "500",
                                                                  }
                                                        }
                                                        onClick={() => {
                                                            this.setState({
                                                                showFourOptions: !showFourOptions,
                                                            });
                                                        }}>
                                                        Add Options C and D
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>
                        <Grid
                            item
                            sx={{
                                zIndex: 1,
                                borderTop: "0.7px solid rgba(0,0,0,0.5)",
                                paddingY: theme.spacing(1),
                            }}>
                            <Grid container justifyContent="center" alignItems="center">
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        sx={{
                                            width: "100px",
                                            fontSize: "12px",
                                            borderRadius: "8px",
                                        }}
                                        disabled={isProcessing}
                                        onClick={this.onSubmit}>
                                        Submit
                                    </Button>
                                </Grid>
                                {/* Footer */}
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <Drawer
                    anchor="bottom"
                    open={drawerOpen}
                    onClose={() => {
                        this.setState({ drawerOpen: false });
                    }}>
                    <Box sx={{ overflow: "auto", height: "250px" }}>
                        <Typography
                            variant="h6"
                            color="#1565C0"
                            sx={{
                                position: "absolute",
                                top: "0px",
                            }}
                            className={classNames(classes.ml, classes.ImageListHeader)}>
                            Collection
                        </Typography>
                        <br />
                        <Grid
                            container
                            direction={"row"}
                            sx={{
                                paddingTop: "30px",
                            }}
                            wrap="nowrap"
                            justifyContent="space-between">
                            {this.imgSrcList.map((img, index) => {
                                return (
                                    <Grid
                                        item
                                        sx={{
                                            p: 1,
                                        }}>
                                        <img
                                            src={getMediaPath(img)}
                                            height="180px"
                                            alt={`Collection-Img ${index}`}
                                            onClick={() => {
                                                this.handleImageChange(img);
                                            }}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </Drawer>
            </Grid>
        );
    }
}

const CreateFlashPage = withStyles(styles)(Component);
export default CreateFlashPage;
